import { axiosClient } from 'api/axios'
import type { LoginParams, LoginResponse, ChangePasswordParams } from './types'

export const login = async (params: LoginParams): Promise<LoginResponse> => {
  try {
    const response = await axiosClient().post<LoginResponse>('/login', params)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const logout = async (): Promise<void> => {
  try {
    await axiosClient().post('/logout')
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const changePassword = async (params: ChangePasswordParams): Promise<void> => {
  try {
    await axiosClient().put('/change_password', params)
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}
